export const IDCardReg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
export const ChinaPhoneReg = /^[1]([3-9])[0-9]{9}$/;
export const ForeignPhoneReg = /^\d{5,14}$/;
// eslint-disable-next-line no-control-regex
export const PasswordSpecialCharactersReg = /[^\u0000-\u00FF]/;
// export const PaymentReg = /(\d+)MT?(\d+)T(\d+)R(\d+)/;
export const PaymentReg = /^[0-9a-zA-Z]+$/;
// eslint-disable-next-line no-useless-escape
export const mailReg = /^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
export const EmailReg = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
